import React from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import styling from './buttonGroup.module.scss'

/**
 * Button groups allow you to group buttons together on a single line, joining their edges
 */
const ButtonGroup = ({ children, className, vertical, size, ...rest }) => {
  const classes = classNames(
    className,
    size && styling[`btn-group-${size}`],
    vertical ? styling['btn-group-vertical'] : styling['btn-group']
  )

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}

ButtonGroup.propTypes = {
  /**
   * The children nodes.
   */
  children: PropTypes.node,
  /**
   * The class name.
   */
  className: PropTypes.string,
  /**
   * The size.
   */
  size: PropTypes.string,
  /**
   * Whether it is vertical, or not.
   */
  vertical: PropTypes.bool,
}

export default ButtonGroup
